import { Promotions } from "./pages/promotions"
import { TouristPrivilege } from "./pages/tourist-privilege"
import { themeOptionFactory } from "./theme"

export const touristFriendly = {
  themeOptionFactory,
  ignoreAppThemeFactory: true,
  routes: {
    mobile: [
      {
        path: "promotions",
        element: <Promotions />,
      },
      {
        path: "tourist-privileges",
        element: <TouristPrivilege />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
